<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-dialog class="media_dialog" :md-active.sync="showDialog">
        <md-dialog-title>Create a new Collection</md-dialog-title>

        <md-field v-if="step == 1">
          <label for="medias">Collection Title</label>
          <md-input v-model="collection.title" class="title"></md-input>
          <md-button @click="step = 2">Next</md-button>
        </md-field>

        <div v-if="step == 2" class="dialog-table">
          <md-table
            :value="galleryTableData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card
            @md-selected="onSelect"
          >
            <md-table-toolbar>
              <h1 class="md-title">Select from Galleries</h1>
            </md-table-toolbar>

            <md-table-toolbar
              slot="md-table-alternate-header"
              slot-scope="{ count }"
            >
              <div class="md-toolbar-section-start">
                {{ getAlternateLabel(count) }}
              </div>

              <div class="md-toolbar-section-end">
                <md-button @click="submitFromLibrary" class="md-button"
                  >Save</md-button
                >
              </div>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select
            >
              <md-table-cell md-label="Title">{{
                item.title.toUpperCase()
              }}</md-table-cell>
              <md-table-cell md-label="# of Photos">{{
                item.media_collection.length
              }}</md-table-cell>
              <md-table-cell md-label="Uploaded By" md-sort-by="uploadedBy">{{
                item.uploadedBy
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog>

      <md-card>
        <md-card-content>
          <md-table
            md-fixed-header
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="medias">Per page</label>
                <md-select v-model="pagination.perPage" name="medias">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-button
                class="md-primary md-round md-small"
                @click="showDialog = true"
                >Add Collection</md-button
              >

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search records"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-tooltip
                v-if="item.uploadedBy != currentUser && item.private"
                md-direction="top"
                >You don't have access to {{ item.uploadedBy }}'s content due to
                privacy turned on</md-tooltip
              >
              <md-table-cell md-label="Title">{{
                item.title.toUpperCase()
              }}</md-table-cell>
              <md-table-cell md-label="# of Galleries">{{
                item.gallery_collection.length
              }}</md-table-cell>
              <!-- <md-table-cell md-label="Icon">
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="openLink(item.url)"
                >
                  <md-icon>image</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Size" md-sort-by="size">{{ convertSize(item.size) }}</md-table-cell>
              <md-table-cell md-label="Date" md-sort-by="date">{{ item.date | format_date }}</md-table-cell>
              <md-table-cell md-label="Tags" md-sort-by="tags">
                <md-chip v-for="(tag, i) in item.tags" :key="i">{{tag.text}}</md-chip>
              </md-table-cell>-->
              <md-table-cell md-label="Uploaded By" md-sort-by="uploadedBy">{{
                item.uploadedBy
              }}</md-table-cell>
              <md-table-cell
                v-if="item.uploadedBy == currentUser"
                md-label="Private"
              >
                <md-switch
                  @change="updatePrivacy(item)"
                  v-model="item.private"
                  :value="true"
                >
                  <span>{{ item.private ? "Yes" : "No" }}</span>
                </md-switch>
              </md-table-cell>

              <md-table-cell v-else md-label="Private">
                <span>{{ item.private ? "Yes" : "No" }}</span>
              </md-table-cell>

              <md-table-cell md-label="Edit">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="openLink('/collection/' + item.id)"
                  :disabled="item.uploadedBy !== currentUser && item.private"
                >
                  <md-icon style="color: rgb(31, 71, 154) !important"
                    >edit</md-icon
                  >
                </md-button>
              </md-table-cell>

              <md-table-cell md-label="Delete">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                  :disabled="item.uploadedBy !== currentUser && item.private"
                >
                  <md-icon style="color: rgb(31, 71, 154) !important"
                    >close</md-icon
                  >
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import { db, auth } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import router from "@/router";
import Upload from "@/components/Inputs/Upload.vue";

export default {
  components: {
    Pagination,
    Upload
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
    currentUser() {
      return auth.currentUser.displayName;
    }
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      footerTable: [
        "media",
        "Description",
        "Last Signal",
        "URL",
        "Reports",
        "Edit",
        "Delete"
      ],
      selected: [],
      searchQuery: "",
      propsToSearch: ["description", "last_signal", "slug"],
      tableData: [],
      galleryTableData: [],
      searchedData: [],
      fuseSearch: null,
      showDialog: false,
      step: 1,
      showCollectionDialog: false,
      selectedCollection: null,
      collection: {
        title: null,
        private: false,
        gallery_collection: [],
        uploadedBy: null
      }
    };
  },
  firestore() {
    return {
      tableData: db.collection("collection"),
      galleryTableData: db.collection("gallery")
    };
  },
  methods: {
    openLink(slug) {
      this.$router.push(slug);
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    convertSize(size) {
      if (size > 0 && size <= 999999) {
        return parseFloat(size / 1000).toFixed(2) + " KB";
      } else {
        return parseFloat(size / 1000000).toFixed(2) + " MB";
      }
    },
    addMedia(media) {
      this.media = media;
    },
    addTag() {
      this.media.tags.push({ text: null });
    },
    removeTag(tag) {
      this.media.tags = this.media.tags.filter((t, i) => t.text !== tag.text);
    },
    updatePrivacy(item) {
      db.collection("collection")
        .doc(item.id)
        .update({ private: item.private });
    },
    submitFromLibrary() {
      if (!this.collection.created) {
        this.collection.created = new Date().getTime();
      }

      let ref = db.collection("collection").doc();
      this.collection.uploadedBy = this.currentUser;

      ref
        .set(this.collection)
        .then(() => {
          this.collection = {
            title: null,
            private: false,
            gallery_collection: []
          };
        })
        .then(() => {
          return Swal.fire(
            "Success",
            "Your file has been uploaded!",
            "success"
          );
        })
        .catch(err => {
          return Swal.fire(
            "Error",
            "Your file couldn't be uploaded, Try again later",
            "warning"
          );
        });
    },

    showImage(item) {
      let id = item.id;
    },
    onSelect(items) {
      this.collection.gallery_collection = items.map(i => i.id);
    },
    getAlternateLabel(count) {
      let plural = "";

      if (count > 1) {
        plural = "s";
      }

      return `${count} user${plural} selected`;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("collection")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
            });
        }
      });
    }
  },

  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "url"],
      threshold: 0.3
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.media_dialog {
  width: 800px;
  overflow-y: auto;
  height: 600px;
}

.md-dialog {
  max-width: 768px;
}

.tabs {
  margin-top: 5%;
}
</style>
